import React, { useEffect, useState } from "react";
import { Link, Route, Switch, useParams, useRouteMatch } from "react-router-dom";

import { Row, Divider, Typography, Tag, Menu, Icon, Breadcrumb } from "antd";

import SurveyAnalytics from "./SurveyAnalytics";
import SurveyResponses from "./SurveyResponses";

import FloatingActionButton from "components/FloatingActionButton/FloatingActionButton";
import Loader from "components/Loader/Loader";

import { fetchSurveyResponseCountApi } from "utils/apiService";

const { Text } = Typography;

const SurveyForm = (props) => {
	let { path, url } = useRouteMatch();
	const { formID } = useParams();

	const [loading, setloading] = useState(true);
	const [formDetail, setFormDetail] = useState({
		form_title: "",
		form_status: "",
		response_count: 0,
	});

	useEffect(() => {
		fetchSurveyResponseCountApi({
			requestData: {
				uuid: formID,
			},
			resCallback: () => {
				loading && setloading(false);
			},
			res200Callback: (res) => {
				delete res.data.status;
				setFormDetail({ ...res.data });
			},
		});
	}, []);

	return loading ? (
		<Row type="flex" align="middle" justify="center" style={{ marginTop: "200px" }}>
			<Loader />
		</Row>
	) : (
		<>
			<Row type="flex" align="middle">
				<Text style={{ color: "#181818", /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "39px" }}>
					{formDetail.form_title}
				</Text>
				<Divider type="vertical" style={{ margin: "0 12px", height: 24 }} />
				{formDetail.form_status === "Stopped" ? <Tag color="grey">Stopped</Tag> : <Tag color="green">Running</Tag>}
			</Row>
			<Breadcrumb style={{ margin: "12px 0" }} separator={<span style={{ color: "#747474" }}>{"<"}</span>}>
				<Breadcrumb.Item
					style={{ /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
					<Link to={"/app-feedback"}>Survey</Link>
				</Breadcrumb.Item>
				<Breadcrumb.Item
					style={{ /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#464646" }}>
					{formDetail.form_title}
				</Breadcrumb.Item>
			</Breadcrumb>
			<Menu
				/*onClick={this.handleClick}*/
				defaultSelectedKeys={props.location.pathname.split("/")[3] === undefined ? "summary" : "responses"}
				mode="horizontal"
				style={{ backgroundColor: "transparent" }}>
				<Menu.Item key="summary">
					<Link to={`${url}`}>
						<Icon type="line-chart" />
						Summary
					</Link>
				</Menu.Item>
				<Menu.Item key="responses">
					<Link to={`${url}/responses`}>
						{/* <Icon type="appstore" /> */}
						Responses {`(${formDetail.response_count})`}
					</Link>
				</Menu.Item>
			</Menu>

			<Switch>
				<Route exact path={`${path}`} component={SurveyAnalytics} />
				<Route exact path={`${path}/responses`} component={SurveyResponses} />
				{/* <Route path="*" component={() => <>404 NOT FOUND</>}></Route> */}
			</Switch>

			<FloatingActionButton
				iconType="edit"
				tooltipTitle={<Text style={{ color: "#fec708" }}>Edit this form</Text>}
				handleClick={() => {
					props.history.push(`${url}/edit`);
				}}
			/>
		</>
	);
};

export default SurveyForm;
